import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { EGDSInput } from '../../input/input/index.esm.js';
import '../../input/faux-input/index.esm.js';
import '../../input/password-input/index.esm.js';
import '../../input/informative-input/index.esm.js';
import '../../input/textarea/index.esm.js';
import '../../input/chat-textarea/index.esm.js';
import '../../input/fake-input/index.esm.js';
import '../../input/card-number-input/index.esm.js';
import '../../input/select/index.esm.js';
import '../../input/swapper-input/index.esm.js';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-typeahead.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
class EGDSTypeaheadInput extends React.Component {
  static displayName = 'EGDSTypeaheadInput';
  render() {
    const {
      className,
      placeholder,
      required,
      ...props
    } = this.props;
    const cssClassNames = getClassNameList('uitk-typeahead-input', className);
    return jsx(EGDSInput, {
      ...props,
      autoCapitalize: "off",
      autoComplete: "off",
      autoCorrect: "off",
      className: cssClassNames,
      type: "text",
      spellCheck: false,
      placeholder: placeholder,
      required: required
    });
  }
}
export { EGDSTypeaheadInput };